import { createSlice, PayloadAction } from "@reduxjs/toolkit"

const slice = createSlice({
  name: 'CommentsApp',
  initialState: {
    isCommentsFetched: false
  },
  reducers: {
    setIsCommentsFetched(state, action: PayloadAction<boolean>) {
      state.isCommentsFetched = action.payload
    }
  }
})

export const commentsAppReducer = slice.reducer
export const { setIsCommentsFetched } = slice.actions
